<template>
  <div>
    <section class="breadcrumb_nav hidden-xs hidden-sm">
      <div class="breadcrumb_nav_img relative">
        <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1668499027_21.jpg" alt="img" />
        <h2 class="breadcrumb_nav_title text-center hidden-xs">
          {{ $t("products.banneTitle") }}
        </h2>
      </div>

      <div class="breadcrumb_nav_wrap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb_nav_box">
                <ul class="breadcrumb_nav_list">
                  <li>
                    <a href="/">{{ $t("products.navTxt1") }}</a>
                  </li>

                  <li>
                    <i class="fa fa-angle-double-right"></i>
                    <a href="/Products">{{ $t("products.navTxt2") }}</a>
                  </li>
                  <!-- <li>
                                        <i class="fa fa-angle-double-right"></i>
                                        <a :href="`/ProductDetail?id=${id}`">Electric
                                            Mountain Bike </a>
                                    </li> -->

                  <li>
                    <i class="fa fa-angle-double-right"></i>
                    <span>{{ info.productName }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <main>
      <section class="description-section">
        <div class="container">
          <div class="row">
            <div class="col-lg-5 col-md-6">
              <div class="product-image-show" style="border: 1px solid #eee">
                <ul id="lightslider">
                  <li v-for="item in info.photoList" :key="item.id" :data-thumb="item">
                    <div class="image-box">
                      <img :src="item" width="100%" />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-7 col-md-6">
              <div class="product-description">
                <h2>{{ info.productName }}</h2>
                <hr />
                <div class="content-style">
                  <div v-html="info.productDescribe"></div>
                  <template v-if="info.parameters&&info.parameters.length">
                    <br/>
                    <div v-for="(item, i) in info.parameters" :key="i">
                      <label style="font-weight: 400">
                         - <input v-model="parameterId" :value="item.id" type="checkbox" style="margin-right: 10px;">{{item.parameterName}}
                        <span style="margin-left: 20px;font-weight: 400;">Price({{info.currency}}): {{item.parameterPrice}}</span>
                      </label>
                    </div>
                  </template>
                </div>
                <hr />
                <div style="margin: 10px 0;">
                  <span>{{ $t("account.price") }}({{info.currency}}): <span style="color: #e7141a;font-size: 22px;font-weight: 700;">{{total}}</span></span>
                  <span style="margin-left: 20px;">{{ $t("account.postage") }}({{info.currency}}): {{info.postage}}</span>
                </div>
                <div class="buttons">
                  <input :value="number" @change="e=>{if(e.target.value>=1)number=e.target.value}" class="form-control" style="width: 80px; display: inline-block; margin-right: 20px" type="number" :placeholder="$t('account.number') + ''" name="number" />
                  <button @click="$router.push(`/Confirm?id=${info.id}&number=${number}&parameterId=${parameterId.join(',')}`)" class="btn btn-primary" style="font-size: 16px">{{ $t("account.now") }}{{ $t("account.buy") }}</button>
                  <!-- <a
                    href="/Contact"
                    class="btn btn-secondary"
                    style="font-size: 16px"
                    >{{ $t("products.itemBtn1") }}</a
                  > -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="section-margin-1x">
        <div class="container">
          <hr />
        </div>
      </div>

      <section class="details-section img-res">
        <div class="container">
          <div class="product-tab dg-tab">
            <div class="dg-tab-nav">
              <div class="dg-tab-action" @click="indexs = 1" :class="{ active: indexs == 1 }">
                {{ $t("products.navTitle1") }}
              </div>
              <div class="dg-tab-action" @click="indexs = 2" v-if="info.record" :class="{ active: indexs == 2 }">
                {{ $t("products.navTitle2") }}
              </div>
              <div class="dg-tab-action" @click="indexs = 3" v-if="info.problems && info.problems.length" :class="{ active: indexs == 3 }">
                {{ $t("products.navTitle3") }}
              </div>
            </div>
            <!-- Tab panes -->
            <div class="dg-tab-content active" v-show="indexs == 1" v-html="info.details"></div>
            <div class="dg-tab-content active" v-show="indexs == 2" v-html="info.record"></div>
            <div class="dg-tab-content active" :style="{ height: indexs == 3 ? 'auto' : 0, overflow: 'hidden' }">
              <div class="panel-group" id="panel-837788">
                <div v-for="(item, i) in info.problems" :key="i" class="panel panel-default">
                  <div class="panel-heading">
                    <a class="panel-title collapsed" data-parent="#panel-837788" data-toggle="collapse">{{ item.problem }}</a>
                  </div>
                  <div class="panel-collapse collapse" id="panel-element-75380">
                    <div class="panel-body" v-html="item.answer"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="section-margin-2x"></div>
      <div class="section-margin-2x"></div>
    </main>
  </div>
</template>

<script setup>
import { watch, onMounted, ref, computed } from "vue"
import i18n from "@/i18n"
import axios from "axios"
import router from "@/router"
import { getProductInfo } from "@/utils/api"

const id = ref(router.currentRoute.query.productId)
const number = ref(1)
const indexs = ref(1)
const parameterId = ref([])
const info = ref({})

const total = computed(()=>{
  const t = info.value.parameters && info.value.parameters.filter(item => parameterId.value.includes(item.id)).reduce((acc, cur)=>acc+Number(cur.parameterPrice),0)
  return (Number(info.value.productPrice) + t) * number.value
})

const getList = () => {
  getProductInfo({ productId: id.value, language: i18n.locale }).then((res) => {
    info.value = res.data
    setTimeout(() => {
      $("#lightslider:not(.bound)").lightSlider({
        gallery: true,
        autoWidth: false,
        item: 1,
        loop: true,
        slideMargin: 0,
        thumbItem: 5,
        pauseOnHover: true,
        rtl: "rtl" === document.querySelector("html").getAttribute("dir")
      })
      $("#lightslider").addClass("bound")

      // $("#RelatedProducts:not(.bound)").lightSlider({
      //   loop: true,
      //   item: 4,
      //   pauseOnHover: true,
      //   rtl: "rtl" === document.querySelector("html").getAttribute("dir"),
      //   responsive: [
      //     {
      //       breakpoint: 1000,
      //       settings: {
      //         item: 2
      //       }
      //     },
      //     {
      //       breakpoint: 768,
      //       settings: {
      //         item: 1
      //       }
      //     }
      //   ]
      // })
      // $("#RelatedProducts").addClass("bound")

      // $("#RecommendProducts:not(.bound)").lightSlider({
      //   auto: true,
      //   loop: true,
      //   pauseOnHover: true,
      //   rtl: "rtl" === document.querySelector("html").getAttribute("dir"),
      //   responsive: [
      //     {
      //       breakpoint: 1000,
      //       settings: {
      //         item: 2
      //       }
      //     },
      //     {
      //       breakpoint: 768,
      //       settings: {
      //         item: 1
      //       }
      //     }
      //   ]
      // })
      // $("#RecommendProducts").addClass("bound")

      $(".details-section .panel").length &&
        $(".details-section .panel-heading:not(.bound)").on("click", function () {
          $(this).toggleClass("active-panel"), $(this).parent(".panel").children(".panel-collapse").slideToggle()
        })
      $(".details-section .panel-heading").addClass("bound")
    }, 300)
  })
}

// getList();
watch(
  () => i18n.locale,
  (currentValue, prevValue) => {
    getList()
  }
)

onMounted(() => {
  getList()
})
</script>
<style scoped>
main .description-section {
  margin-top: 70px;
}

main .btn-secondary:hover {
  color: #fff !important;
}

main .nav-tabs .nav-item.active .nav-link {
  border-top-color: var(--main-theme-color) !important;
  font-size: 16px;
}

main .content-style {
  font-size: 16px;
}

main .details-section .tab-content ul,
main .details-section .tab-content ol {
  padding-left: 20px;
}

main .details-section ol li {
  list-style: inherit;
}

main .details-section ul li {
  list-style: initial;
}

main .content-style h3 {
  border-left: 0.12em solid var(--main-theme-color);
}

main .content-style h2:after,
main .section-head h2:after {
  background-color: var(--main-theme-color);
}

main iframe {
  max-width: 100%;
}

.thumbnail {
  line-height: 16px;
}

main .thumbnail a {
  padding-bottom: inherit;
  display: initial;
}

main .thumbnail > a {
  padding-bottom: 100%;
}

main .thumbnail a img {
  position: static;
}

main .section-head h2 {
  font-size: 25px;
  margin-top: 0;
}

main .thumbnail h3 {
  height: auto;
}

main .thumbnail h3 a {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  vertical-align: middle;
  font-size: 20px;
  line-height: 24px;
  height: 48px;
}

main .product-image-show img {
  width: 100%;
}

main .tab-content {
  font-size: 16px;
  padding: 1rem;
  line-height: 1.5em;
  border-top: 1px solid #ddd;
  margin-top: -1px;
}

.lSSlideOuter .lSPager.lSGallery li {
  float: left;
  width: 20%;
}

.lSSlideOuter .lSPager.lSpg > li.active a,
.lSSlideOuter .lSPager.lSpg > li:hover a {
  background-color: var(--main-theme-color);
}

main .thumbnail p {
  font-size: 16px;
  -webkit-line-clamp: initial;
  height: auto;
  line-height: 1.4em;
}

main img {
  border: none;
}

[dir="rtl"] main .section-head h2:after {
  left: auto;
  right: 0;
}

.dg-tab .dg-tab-nav {
  font-size: 0;
}

.dg-tab .dg-tab-action {
  display: inline-block;
  background-color: #fff;
  width: 280px;
  cursor: pointer;
  font-size: 18px;
  border: 1px solid #e9ecef;
  border-top-width: 3px;
  padding: 0.5rem 1rem;
  text-align: center;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.dg-tab .dg-tab-action.active {
  background-color: #fff;
  border-bottom-color: #fff;
  border-top-color: var(--main-theme-color);
}

.dg-tab .dg-tab-panel {
  border: 1px solid #ddd;
  padding: 15px;
  margin-top: -1px;
}

.dg-tab .dg-tab-content {
  display: none;
}

.dg-tab .dg-tab-content.active {
  display: block;
}

.dg-tab .dg-tab-content .thumbnail p {
  height: auto;
  -webkit-line-clamp: initial;
}

.dg-tab .dg-tab-content .thumbnail {
  margin-bottom: 20px;
}

@media (max-width: 996px) {
  .dg-tab .dg-tab-action {
    display: inline-block;
    width: 100%;
    background-color: #eee;
    margin-bottom: 10px;
  }

  .dg-tab .dg-tab-action.active {
    border-bottom-color: #ddd;
  }
}

@media only screen and (min-width: 992px) {
  main .product-description h2 {
    font-size: 26px;
  }
}

@media only screen and (max-width: 991px) {
  main .description-section {
    margin-top: 60px;
  }
}

@media only screen and (max-width: 767px) {
  main .section-margin-2x {
    margin: 40px;
  }

  main .section-margin-1x {
    margin: 20px 10px;
  }

  main .section-head h2 {
    font-size: 22px;
  }

  main .description-section {
    margin-top: 50px;
  }
}
</style>
